var _style, _g, _circle, _line, _line2, _line3, _line4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCoin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#638B3F;}\n\t.st1{fill:#88C057;}\n\t.st2{display:none;}\n\t.st3{display:inline;}\n\t.st4{fill:#FFFFFF;}\n\t.st5{fill:none;stroke:#FFFFFF;stroke-width:40;stroke-miterlimit:10;}\n\t.st6{fill:none;stroke:#FFFFFF;stroke-width:25;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20830_"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 258.4,
    r: 256
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 256,
    cy: 258.4,
    r: 203.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 256,
    cy: 258.4,
    r: 167.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20838_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21011_",
    className: "st1",
    d: "M13.9,252.5h27.8v11.9H13.9V252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21010_",
    className: "st1",
    d: "M470.3,252.5h27.8v11.9h-27.8V252.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21009_",
    className: "st1",
    d: "M18,302.9l27.2-5.8l2.5,11.6l-27.2,5.8L18,302.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21008_",
    className: "st1",
    d: "M494.1,214l-27.2,5.8l-2.5-11.6l27.2-5.8L494.1,214z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21007_",
    className: "st1",
    d: "M32.5,351.7l25.4-11.3l4.8,10.9l-25.4,11.3L32.5,351.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21006_",
    className: "st1",
    d: "M479.4,165.5L454,176.8l-4.8-10.9l25.4-11.3L479.4,165.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21005_",
    className: "st1",
    d: "M63.6,405.5l-7-9.6l22.5-16.3l7,9.6L63.6,405.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21004_",
    className: "st1",
    d: "M448.5,111.3l7,9.6L433,137.3l-7-9.6L448.5,111.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21003_",
    className: "st1",
    d: "M98.4,442.4l-8.8-7.9l18.6-20.6l8.8,7.9L98.4,442.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21002_",
    className: "st1",
    d: "M403.9,103.2l-8.8-7.9l18.6-20.6l8.8,7.9L403.9,103.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21001_",
    className: "st1",
    d: "M140.1,471.1l-10.3-5.9l13.9-24.1L154,447L140.1,471.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_21000_",
    className: "st1",
    d: "M368.2,75.9L358,69.9l13.9-24.1l10.3,5.9L368.2,75.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20999_",
    className: "st1",
    d: "M186.9,490.6l-11.3-3.7l8.6-26.4l11.3,3.7L186.9,490.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20998_",
    className: "st1",
    d: "M327.9,56.4l-11.3-3.7l8.6-26.4l11.3,3.7L327.9,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20997_",
    className: "st1",
    d: "M236.4,499.7l-11.8-1.2l2.9-27.6l11.8,1.2L236.4,499.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20996_",
    className: "st1",
    d: "M284.2,46l-11.8-1.2l2.9-27.6l11.8,1.2L284.2,46z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20995_",
    className: "st1",
    d: "M275.7,499.9l-2.9-27.6l11.8-1.2l2.9,27.6L275.7,499.9z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20994_",
    className: "st1",
    d: "M227.7,45.8l-2.9-27.6l11.8-1.2l2.9,27.6L227.7,45.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20993_",
    className: "st1",
    d: "M325.1,490.5l-8.6-26.4l11.3-3.7l8.6,26.4L325.1,490.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20992_",
    className: "st1",
    d: "M184.1,56.4L175.5,30l11.3-3.7l8.6,26.4L184.1,56.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20848_",
    className: "st1",
    d: "M371.8,471.1L357.9,447l10.3-5.9l13.9,24.1L371.8,471.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20847_",
    className: "st1",
    d: "M143.6,75.8l-13.9-24.1l10.3-5.9l13.9,24.1L143.6,75.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20846_",
    className: "st1",
    d: "M413.6,442.4l-18.6-20.6l8.8-7.9l18.6,20.6L413.6,442.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20845_",
    className: "st1",
    d: "M108.2,103.1L89.6,82.5l8.8-7.9L117,95.2L108.2,103.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20844_",
    className: "st1",
    d: "M448.6,405.4l-22.5-16.3l7-9.6l22.5,16.3L448.6,405.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20843_",
    className: "st1",
    d: "M79.2,137.2l-22.5-16.3l7-9.6l22.5,16.3L79.2,137.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20842_",
    className: "st1",
    d: "M474.8,362l-25.4-11.3l4.8-10.9l25.4,11.3L474.8,362z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20841_",
    className: "st1",
    d: "M37.2,154.6l25.4,11.3l-4.8,10.9l-25.4-11.3L37.2,154.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20840_",
    className: "st1",
    d: "M491.7,314.6l-27.2-5.8l2.5-11.6l27.2,5.8L491.7,314.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20839_",
    className: "st1",
    d: "M20.4,202.3l27.2,5.8l-2.5,11.6l-27.2-5.8L20.4,202.3z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20834_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20837_",
    className: "st4",
    d: "M187,442.3l9.1-14.3l-14.3,9.1l-6.3-28.3l-6.3,28.3l-14.3-9.1l9.1,14.3l-28.3,6.3 l28.3,6.3l-9.1,14.3l14.3-9.1l6.3,28.3l6.3-28.3l14.3,9.1l-9.1-14.3l28.3-6.3L187,442.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20836_",
    className: "st4",
    d: "M149.3,121.2l-23-5.1l7.4-11.6l-11.6,7.4l-5.1-23l-5.1,23l-11.6-7.4l7.4,11.6l-23,5.1 l23,5.1l-7.4,11.6l11.6-7.4l5.1,23l5.1-23l11.6,7.4l-7.4-11.6L149.3,121.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20835_",
    className: "st4",
    d: "M459.6,153.5l-23-5.1l7.4-11.6l-11.6,7.4l-5.1-23l-5.1,23l-11.6-7.4l7.4,11.6l-23,5.1 l23,5.1l-7.4,11.6l11.6-7.4l5.1,23l5.1-23l11.6,7.4l-7.4-11.6L459.6,153.5z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_20831_",
    className: "st3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20833_",
    className: "st4",
    d: "M220.8,314.7l-21.1-21.1V121.7c-53.7,22.1-91.5,75-91.5,136.7 c0,81.6,66.2,147.8,147.8,147.8c12.5,0,24.6-1.6,36.2-4.5v-87.1H220.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_20832_",
    className: "st4",
    d: "M403.8,258.4c0-81.6-66.2-147.8-147.8-147.8c-12.5,0-24.6,1.6-36.2,4.5v87.1h71.4 l21.1,21.1v171.8C366,373,403.8,320.1,403.8,258.4L403.8,258.4z"
  }))))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 256,
    cy: 258.4,
    r: 90.8
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 231.9,
    y1: 111.3,
    x2: 231.9,
    y2: 154.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 280.2,
    y1: 111.3,
    x2: 280.2,
    y2: 154.6
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 231.9,
    y1: 362.2,
    x2: 231.9,
    y2: 405.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st6",
    x1: 280.1,
    y1: 362.2,
    x2: 280.1,
    y2: 405.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoin);
export default __webpack_public_path__ + "static/media/coin.5dd40a7e41624594565bd09ff1582f0a.svg";
export { ForwardRef as ReactComponent };